import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {useNullableProcedureFlowchartValidationContext} from 'procedures/processes/useNullableProcedureFlowchartValidationContext';

import {StaticTemplateFlowchart} from './processFlowchartConfigEditorConstants';

/**
 * Hook to compute validation context for flowchart validation based on execution type.
 *
 * This hook is platform-agnostic and delegates to application-specific implementations
 * based on the execution type. Application teams should provide their own implementations
 * for their specific execution types.
 *
 * @param executionType The execution type of the flowchart
 * @param draftFlowchartConfig The draft flowchart configuration
 * @returns Validation context object, or empty object if no application-specific implementation exists
 */
export function useApplicationFlowchartValidationContext(
  executionType: ProcessExecutionType,
  draftFlowchartConfig: StaticTemplateFlowchart
): Record<string, unknown> {
  const procedureValidationContext = useNullableProcedureFlowchartValidationContext(draftFlowchartConfig);

  // Only use the procedure validation context if we're actually in a procedure execution type
  if (executionType === ProcessExecutionType.PROCEDURE) {
    return procedureValidationContext;
  }

  return {};
}
